import { Text } from "../../../../../core/Text.js";
import { ActionButton } from "../../../../shared/ActionButton.js";
import type { BattlesHeadingContent } from "../../../battlesContent.js";

/** The lobby's one h1, what a battle is, and the way to start one. */
export function BattlesHeading({ title, description, action }: BattlesHeadingContent) {
  return (
    <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
      <div className="flex min-w-0 flex-col gap-2">
        <Text as="h1" variant="display-xl2" tone="primary" className="max-md:text-display-xl3">
          {title}
        </Text>
        <Text as="p" variant="body-b1" tone="secondary" className="max-w-2xl">
          {description}
        </Text>
      </div>
      <ActionButton
        action={{ label: action.label, href: action.href }}
        variant={action.emphasis === "primary" ? "primary" : "secondary"}
        size="lg"
        className="self-start md:self-auto"
      />
    </div>
  );
}
